module.exports = __webpack_public_path__ + "static/media/slide-rain-gutters.8e7528dd.jpg";